// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610190605/js/" + chunkId + "." + {"44":"96c9b014","225":"98c270ac","481":"d606dbda","486":"be90f2a9","770":"23e9eac0"}[chunkId] + ".0.497947214945201.chunk.js";
};